import { render } from "./gonggao.vue?vue&type=template&id=557307c0&scoped=true"
import script from "./gonggao.vue?vue&type=script&lang=js"
export * from "./gonggao.vue?vue&type=script&lang=js"

import "./gonggao.vue?vue&type=style&index=0&id=557307c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-557307c0"],['__file',"src/pages/gonggao.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "557307c0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('557307c0', __exports__)) {
    api.reload('557307c0', __exports__)
  }
  
  module.hot.accept("./gonggao.vue?vue&type=template&id=557307c0&scoped=true", () => {
    api.rerender('557307c0', render)
  })

}


export default __exports__